import React from 'react';
import {Container, Stack, Typography} from '@mui/material';
import withMainContainer from '../components/WithMainContainer.js';
import TarotSpreadComp from '../components/TarotSpreadComp.js';
import WhatsAppButton from '../components/WhatsAppButton.js';

const CtaComp = props=>{
    let {question, card} = props;
    console.log({question, card});
    return <WhatsAppButton text="קביעת פגישה לפירוש המסר לעומק בתשלום"
      message={`היי, יצא לי ${card.title} במסר היומי בנושא "${question}". אשמח לקבוע פגישה לפירוש המסר לעומק :)`}/>;
};

const TarotSpreadPage = ()=>{
    return <Stack direction="column">
      <Container maxWidth="lg">
        <Stack direction="column" gap={2}>
          <Typography variant="h3" textAlign="center">
            מסר מהקלפים - כאן ועכשיו
          </Typography>
          <Typography>
            לפעמים כל מה שאנחנו צריכים הוא רגע לעצור… לנשום… ולקבל את התובנה המדויקת בזמן הנכון.
          </Typography>
          <Typography>
            כדי לקבל את המסר שלכם:
            <ol>
              <li><strong>עצמו עיניים, נשמו עמוק</strong> ותנו ללב לבחור על מה תרצו לקבל מסר - בתחום בחיים, או נושא שחשוב לכם עכשיו.</li>
              <li><strong>כתבו את הנושא</strong> בשדה שמתחת.</li>
              <li><strong>ערבבו את הקלפים</strong> בלחיצה ועצרו כשתרגישו שזה הרגע.</li>
              <li><strong>בחרו קלף מהמניפה</strong> והוא יגלה לכם את המסר שלכם להיום.</li>
            </ol>
          </Typography>
          <Typography>
            אפשר לחזור על זה כמה פעמים שתרצו עם נושאים שונים.<br/>
            ואם תרצו להבין לעומק את המסר שיצא לכם - מתחת למסר יחכה לכם כפתור לשליחת הודעה אליי בוואטסאפ, עם כל הפרטים שכבר ימולאו עבורכם.
          </Typography>
        </Stack>
      </Container>
      <Stack padding={4}>
        <TarotSpreadComp CtaComp={CtaComp}/>
      </Stack>
    </Stack>;
};

export default withMainContainer(TarotSpreadPage, {footerMargin: 4});
